export enum ManageProfileTabs {
  COMMUNICATION_PREFERENCES = 'COMMUNICATION_PREFERENCES',
  REIMBURSEMENT_OPTIONS = 'REIMBURSEMENT_OPTIONS',
  DEPENDENTS = 'DEPENDENTS',
  SECURITY = 'SECURITY',
  BENEFICIARIES = 'BENEFICIARIES',
  HELP = 'HELP',
}
